import router from '@/router';
import {push} from 'notivue';
import Swal from "sweetalert2";

export function getUrl(session) {
    const values = JSON.parse(localStorage.getItem(session));
    let url = values.url + '/?';
    const params = values.params;
    const keys = Object.keys(values.params);

    for (let i = 0; i < keys.length; i++) {
        let result = params[keys[i]];
        url += `&${keys[i]}=${result}`;
    }

    return url;
}

export function formDataToJson(id) {
    // Acessar o formulário pelo seu ID
    const form = document.getElementById(id);
    if (!form) {
        console.error('Formulário não encontrado!');
        return null;
    }

    // Criar uma instância de FormData
    const formData = new FormData();

    formData.append('id', document.getElementById('id').value);

    const inputs = form.getElementsByClassName('form-control');
    Array.from(inputs).forEach(input => {
        // Verificar se é um campo de entrada de arquivo
        if (input.type === 'file') {
            // Adicionar cada arquivo selecionado ao objeto FormData
            for (let i = 0; i < input.files.length; i++) {
                formData.append(input.name, input.files[i]);
            }
        } else if (input.type !== 'submit' && input.type !== 'button' && input.name) {
            // Para outros tipos de campos, apenas adicionar ao FormData
            // Ignorando botões de envio e outros elementos interativos que não contêm dados "submetíveis"
            formData.append(input.name, input.value);
        }
    })


    return formData;
}

export function Forbidden(response) {
    if (response.response.status === 401 || response.response.status === 403) {
        localStorage.removeItem('token');
        router.push({
            name: 'login'
        })
    }

    notifyError(response.response.data.message);
}

export function notifyError(message) {
    push.error({
        title: 'Erro!',
        message,
        duration: 5000
    })
}

export function notifySuccess(message) {
    push.success({
        title: 'Sucesso!',
        message,
        duration: 5000
    })
}

export async function deleteElement(message) {
    const text = message || "Seus dados serão removidos e não poderão mais ser recuperados.";
    return Swal.fire({
        title: "Você tem certeza?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
    }).then((result) => {
        return result;
    });
}

export function loadTable() {
    const tbody = document.querySelector('#table tbody');
    if (tbody) tbody.style.opacity = '.2'
    loadCard();
}

export function loadCard(id) {
    if (id) {
        const element = document.getElementById(id);
        element.style.opacity = '.2'
    }
    const placeholderElement = document.querySelector('.simplebar-placeholder');
    const width = parseInt(placeholderElement.offsetWidth) / 2 + 30;

    if (document.getElementById('spinner')) {
        document.getElementById('spinner').style.display = 'block'
        document.getElementById('spinner').style.right = `calc(50% - ${width}px)`
    }
}

export function endLoadTable() {
    const tbody = document.querySelector('#table tbody');
    if (tbody) tbody.style.opacity = '1'

    endLoadCard();
}

export function endLoadCard(id) {
    if (id) {
        const element = document.getElementById(id);
        element.style.opacity = '1'
    }
    document.getElementById('spinner').style.display = 'none'
    document.getElementById('spinner').style.right = `calc(50% - 2.5rem)`
}

export function convertDateText(dateTime) {
    let date = dateTime.split(' ');
    const months = [
        'Jan', 'Fev', 'Mar', 'Abr',
        'Mai', 'Jun', 'Jul', 'Ago',
        'Set', 'Out', 'Nov', 'Dez',
    ];

    date = date[0].split('-');
    const month = months[parseInt(date[1]) - 1];

    return `${date[2]} ${month}, ${date[0]}`;
}

export function encondeId(id) {
    return btoa(id.toString());
}

export function containsHtml(str){
    const htmlPattern = /<\/?[a-z][\s\S]*>/i;
    return htmlPattern.test(str);
}

export function decodeId(id) {
    return atob(id.toString());
}